import { Pipe, PipeTransform } from '@angular/core';
import {AmpouleEnum} from '../parametrage-usages/enums/AmpouleEnum';

@Pipe({
    name: 'ampouleType',
    standalone: false
})
export class AmpouleTypePipe implements PipeTransform {

  transform(value: AmpouleEnum): unknown {
    switch (value) {
      case AmpouleEnum.AMPOULE_FLUOCOMPACTE:
        return 'Fluocompacte';
      case AmpouleEnum.AMPOULE_HALOGENE:
        return 'Halogene';
      case AmpouleEnum.AMPOULE_LED:
        return 'LED';
      case AmpouleEnum.AMPOULE_FLUORESCENT:
        return 'Fluorescent';
    }
  }

}
